
import fetch from 'cross-fetch';
import { getDataUrl } from '../get-data-url';
import { reportErrorSentry } from '../report-error-sentry';

export const fetchHorariosCallMeNow = async () => {
  const dataUrl = getDataUrl();
  // To get data in pre add the replace
  // .replace('https://', 'https://pre-');

  return fetch(dataUrl + '/getHorariosCallMeNow')
    .then((response) => {
      return response.json();
    }).catch((err) => {
      reportErrorSentry(err);
    });
};
